export const PreviousSlideIcon = () => (
    <svg id="icon-slide-prev" xmlns="http://www.w3.org/2000/svg" className="h-2.5em w-2.5em stroke-white" viewBox="0 0 40 40" aria-hidden="true">
        <path d="m23.59,11l-8.9,8.34c-.38.36-.38.96,0,1.31l8.9,8.34" fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
    </svg>
);
